import { render } from "./Informations_Options.vue?vue&type=template&id=ed0353b6"
import script from "./Informations_Options.vue?vue&type=script&lang=js"
export * from "./Informations_Options.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__